import { WorkspaceEmailPostmasterToolsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/email/postmaster_tools')(
  {
    component: WorkspaceEmailPostmasterToolsRoute,
  },
);
